'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { handleActions } from 'flux-actions';
import { PORTAL_AUTH_SUCCEEDED } from '../actions/ActionTypes';
export default handleActions(_defineProperty({}, PORTAL_AUTH_SUCCEEDED, function (state, action) {
  return action.payload;
}), null);